import React, { useState } from 'react';
import { Button } from "@material-ui/core";
import services from '../../Services';
import moment from 'moment-timezone';
import { DatePicker, message, Modal } from 'antd';

const { hr } = services;

const HireDateModal = ({ HireEditModal }) => {

  let { employeeDetails, open, close, mainFlag, setMainFlag } = HireEditModal;
  const [InitialDate, setInitialDate] = useState(moment(employeeDetails?.hireDate)?.utc())


  function onUpdateHireModal() {
    if (!InitialDate) return message?.error("Please select any date!")

    let data = {
      effective_date: moment(InitialDate).format('YYYY-MM-DD'),
      id: employeeDetails?.id
    }

    try {
      hr.updateEditHireModalApi(data).then(() => {
        setMainFlag(!mainFlag)
      }).catch((err) => { });
      close(false);
    }
    catch (exc) {
      close(false);
    }
  }


  return (
    <Modal
      open={open}
      onCancel={() => close(false)}
      title={"Edit hire date"}
      footer={false}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        <DatePicker
          value={InitialDate}
          style={{ padding: "15px" }}
          onChange={e => setInitialDate(e?.utc())}
          allowClear={false}
          format={"MM-DD-YYYY"}

        />
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <Button onClick={() => onUpdateHireModal()} style={{ width: "50%" }} className="LinkButton">
            Save
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default HireDateModal